export default __webpack_public_path__ + "static/media/thumbnil3.691fb3d8.png";